import { APIClient } from '@innerhive-internal/innerhive-api-client';
import { IonButton } from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useState } from 'react';
import { AlertPresenter } from '../AlertPresenter';
import { ITriggerOnboardingNotificationsResponse } from '../support/DebugPage';

export const NotificationsDevTools: React.FC = () => {
    const apiClient = useInstance(APIClient);
    const alertPresenter = useInstance(AlertPresenter);
    const [loading, setLoading] = useState(false);

    const triggerOnboardingNotifications = async () => {
        setLoading(true);
        try {
            const entry = await apiClient.entry();
            const adminCommandsLink = entry?.links?.adminCommands;
            if (!adminCommandsLink) {
                throw new Error('Admin commands endpoint not available');
            }
            const response: ITriggerOnboardingNotificationsResponse = await apiClient.post(adminCommandsLink, { command: 'trigger-onboarding-notifications' });

            await alertPresenter.showAlertV2({
                header: 'Success',
                message: `Scheduled ${response.scheduledCount} onboarding notifications.`,
                backdropDismiss: true,
                options: [{ id: 'ok', label: 'OK' }]
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : 'Failed to trigger onboarding notifications';
            await alertPresenter.showAlertV2({
                header: 'Error',
                message,
                backdropDismiss: true,
                options: [{ id: 'ok', label: 'OK' }]
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ marginBottom: '8px' }}>
            <IonButton
                fill="outline"
                size="small"
                onClick={triggerOnboardingNotifications}
                disabled={loading}
            >
                {loading ? 'Scheduling...' : 'Send Onboarding Notifications Now'}
            </IonButton>
        </div>
    );
};
